import api from './api';
import { TAG } from './endpoints';

const get = (params = {}) => api.get(`${TAG}/`, { params });

export default {
  get,
};
